import { surfaces } from '@ui/kit/design-tokens';
import { makeInteractiveSurfaceToken } from '@utils/css';

const primaryWithCustomColor = makeInteractiveSurfaceToken(
  "--pm2-primary",
  surfaces.primary
);
const accentWithCustomColor = makeInteractiveSurfaceToken(
  "--pm2-accent",
  surfaces.accent
);

export { accentWithCustomColor, primaryWithCustomColor };
//# sourceMappingURL=surface.js.map
